interface LoaderProps{
    absolute?: boolean
}

const Loader = ({absolute = true}:LoaderProps = {})=>{

    console.log('Loader props '+absolute)

    function getStyle(){
        if(absolute)
         return "pure-material-progress-circular progress-absolute "
        else
         return 'pure-material-progress-circular'
    }

    return <progress className={getStyle()}/>
}

export default Loader